<template>
	<div class="share">
		<a target="_blank" class="share-item share-facebook" :href="facebook">
			<FacebookIcon/>
		</a>
		<a target="_blank" class="share-item share-twitter" :href="twitter">
			<TwitterIcon/>
		</a>
		<!--
		<a class="share-item share-instagram" :href="InstagramUrl">
			<InstaIcon/>
		</a>
		-->
	</div>
</template>

<script>


import FacebookIcon from './icons/facebook.svg';
import TwitterIcon from './icons/twitter.svg';
//import InstaIcon from './icons/instagram.svg';

export default {
	name: 'Share',
	components: {
		FacebookIcon,
		TwitterIcon,
		//InstaIcon,
	},
	data() {
		return {
			facebook: "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(this.url),
			twitter: "https://twitter.com/intent/tweet?text="+ encodeURIComponent(process.env.VUE_APP_TWITTER_DESCRIPTION) +"&url=" + encodeURIComponent(this.url),
		}
	},
	props: {
		url: String,

	},

}
</script>


<style scoped lang="scss">

.share {
	display: flex;

	.share-item {
		border-radius: 50%;
		width: 3rem;
		height: 3rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 1rem;

		&.share-facebook {
			background-color: #3b5998;
		}

		&.share-twitter {
			background-color: #aab8c2;
		}

		&.share-instagram {
			background-color: #405de6;
		}
	}

	svg {
		width: auto;
		transform: scale(1.2);
		transform-origin: 50% 50%;
		>* {
			fill: #fff;
		}
	}
}

</style>
